@for (row of rows(); track row) {
    <div class="modal-panel modal-panel-input">
        @for (field of normalizedFields(); track field) {
            <div class="field">
                @if (!!field.label) {
                    <div class="ft-label">{{ field.label }}</div>
                }
                <textarea
                    [ngStyle]="inlineStyle()"
                    [(ngModel)]="row.fieldData[field.name]"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="required()"
                    [minlength]="minLength()"
                    [attr.ng-maxlength]="maxLength()"
                ></textarea>
            </div>
        }
        @if (languages().length > 1) {
            <div class="language-code">{{ row.language.name }}</div>
        }
    </div>
}

@if (!isMultiLanguage()) {
    @for (field of normalizedFields(); track field) {
        <div class="modal-panel modal-panel-input">
            <div class="field">
                @if (!!field.label) {
                    <div class="ft-label">{{ field.label }}</div>
                }
                <textarea
                    #singleTextarea
                    [ngStyle]="inlineStyle()"
                    [(ngModel)]="datasource()[field.name]"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="required()"
                    [minlength]="minLength()"
                    [attr.ng-maxlength]="maxLength()"
                ></textarea>
            </div>
        </div>
    }
}
